<template>
  <div class="pageStyle">
    <!-- 全屏loading遮罩 -->
    <div class="loading-mask" v-show="isLoading">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">页面加载中...</div>
      </div>
    </div>
    <div class="content">
      <div
        class="item"
        :class="{ 'slide-in-item': startAnimation }"
        v-for="(item, index) in list"
        :key="index"
        @click="toPage(item.pathName)"
        :style="startAnimation ? { animationDelay: index * 0.2 + 's' } : {}"
      >
        <div class="left">
          <div class="left-left">
            <img :src="item.leftIcon" alt="" />
          </div>
          <div class="left-right">
            <span>{{ item.title }}</span
            ><span>{{ item.desc }}</span>
          </div>
        </div>
        <div class="right">
          <img
            src="https://static.xchengtech.cn/6d81cb6fd9644fab8214677f706ef655.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- <div class="foot">
      <span
        ><img
          src="https://static.xchengtech.cn/d470884badc64f729325dbe5dba00ec4.png"
          alt=""
        />联系客服</span
      >
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import Cookies from "js-cookie";
import { getDepNameByDomain } from "@/utils/index.js";
Vue.use(Icon);
Vue.use(Toast);
export default {
  created() {
    // 功能卡片 滑动动画
    this.startAnimation = true;
    this.getDepName();
  },
  data() {
    return {
      isLoading: false, // 全屏loading状态
      // 全屏loading状态
      startAnimation: false, // 控制卡片动画开始
      isCreating: false,
      // 产品列表
      list: [
        {
          title: "财税报告",
          desc: "个人/企业全方位数据分析及详尽报告",
          leftIcon:
            "https://static.xchengtech.cn/611e1e271b6544d38ce2127e8828a769.png",
          pathName: "csbg",
        },
        {
          title: "企业测额",
          desc: "在线测额度 精准匹配产品",
          leftIcon:
            "https://static.xchengtech.cn/1b7bf4138ca94e2b839d5032017fb0ff.png",
          pathName: "qyce",
        },

        {
          title: "信用修复",
          desc: "专业合规修复负面信息 信用重塑",
          leftIcon:
            "https://static.xchengtech.cn/4ba04a7a099a433e8ad27a0fbae8cf68.png",
          pathName: "xyxf",
        },
        {
          title: "债务优化",
          desc: "个人债务 / 结构 / 期限 / 还款方式优化",
          leftIcon:
            "https://static.xchengtech.cn/83dbdc9680db47498e99abf3b01f8427.png",
          pathName: "zwyh",
        },
        {
          title: "补贴信息",
          desc: "企业补贴信息税款 次月返还",
          leftIcon:
            "https://static.xchengtech.cn/95e4be819b114763969fa3680095fd9a.png",
          pathName: "czbt",
        },
        {
          title: "资产配置",
          desc: "境内外保险理财投资等服务",
          leftIcon:
            "https://static.xchengtech.cn/320031b7998d4cfca46b0aa8df578f89.png",
          pathName: "zcpz",
        },
        {
          title: "帐户管理",
          desc: "资金结算支付清分等管理系统解决方案",
          leftIcon:
            "https://static.xchengtech.cn/18091ec6ad754956bcb29e77b9875f6b.png",
          pathName: "zhgl",
        },
      ],
      // 租户链接
      depLink: {
        // 总协会
        jf: {
          channelId: "4f9cb452fcdb4906bbe037e4f709898b",
          // 企业报告
          csbg: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=6bcaf21529664940a722681e76f714fa&channelId=4f9cb452fcdb4906bbe037e4f709898b",
          // 企业测额
          qyce: "https://page.xchengtech.cn/productPage/qyce.html?channelId=4f9cb452fcdb4906bbe037e4f709898b",
          // 信用修复
          xyxf: "https://page.xchengtech.cn/productPage/xyxf.html?channelId=4f9cb452fcdb4906bbe037e4f709898b",
          // 债务优化
          zwyh: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=4f9cb452fcdb4906bbe037e4f709898b",
          // 补贴信息
          czbt: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=4f9cb452fcdb4906bbe037e4f709898b",
          // 资产配置
          zcpz: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=4f9cb452fcdb4906bbe037e4f709898b",
          // 账户管理
          zhgl: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=4f9cb452fcdb4906bbe037e4f709898b",
        },
        // 代理记账协会
        dljzxh: {
          channelId: "95a5bd9d04f5475680967f400a23918d",
          // 企业报告
          csbg: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=a69e50343f02471abaf11573702ee0b2&channelId=95a5bd9d04f5475680967f400a23918d",
          // 企业测额
          qyce: "https://page.xchengtech.cn/productPage/qyce.html?channelId=95a5bd9d04f5475680967f400a23918d",

          // 信用修复
          xyxf: "https://page.xchengtech.cn/productPage/xyxf.html?channelId=95a5bd9d04f5475680967f400a23918d",
          // 债务优化
          zwyh: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=95a5bd9d04f5475680967f400a23918d",
          // 补贴信息
          czbt: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=95a5bd9d04f5475680967f400a23918d",
          // 资产配置
          zcpz: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=95a5bd9d04f5475680967f400a23918d",
          // 账户管理
          zhgl: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=95a5bd9d04f5475680967f400a23918d",
        },
        // 湖南省商业综合体服务协会
        hnssyzhtfwxh: {
          channelId: "0a6ce9ce37134c96b0fe2a4157975229",
          // 企业报告
          csbg: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=a658ef3c792c4e8086a6f994d83b853b&channelId=0a6ce9ce37134c96b0fe2a4157975229",
          // 企业测额
          qyce: "https://page.xchengtech.cn/productPage/qyce.html?channelId=0a6ce9ce37134c96b0fe2a4157975229",

          // 信用修复
          xyxf: "https://page.xchengtech.cn/productPage/xyxf.html?channelId=0a6ce9ce37134c96b0fe2a4157975229",
          // 债务优化
          zwyh: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=0a6ce9ce37134c96b0fe2a4157975229",
          // 补贴信息
          czbt: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=0a6ce9ce37134c96b0fe2a4157975229",
          // 资产配置
          zcpz: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=0a6ce9ce37134c96b0fe2a4157975229",
          // 账户管理
          zhgl: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=0a6ce9ce37134c96b0fe2a4157975229",
        },
        // 湖南退役军人服务平台
        hntyjrpt: {
          channelId: "c01b0b59efd348368b28bba5aafdd684",
          // 企业报告
          csbg: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=a8d58c7d6d0f4d9c82a8d2269d26dd3a&channelId=c01b0b59efd348368b28bba5aafdd684",
          // 企业测额
          qyce: "https://page.xchengtech.cn/productPage/qyce.html?channelId=c01b0b59efd348368b28bba5aafdd684",

          // 信用修复
          xyxf: "https://page.xchengtech.cn/productPage/xyxf.html?channelId=c01b0b59efd348368b28bba5aafdd684",
          // 债务优化
          zwyh: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=c01b0b59efd348368b28bba5aafdd684",
          // 补贴信息
          czbt: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=c01b0b59efd348368b28bba5aafdd684",
          // 资产配置
          zcpz: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=c01b0b59efd348368b28bba5aafdd684",
          // 账户管理
          zhgl: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=c01b0b59efd348368b28bba5aafdd684",
        },
        // 穗空间
        skj: {
          channelId: "74d16ae2bcb04dd48a7e0945ce976211",
          // 企业报告
          csbg: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=1c53bdef1fcf46a1852654c4297661ea&channelId=74d16ae2bcb04dd48a7e0945ce976211",
          // 企业测额
          qyce: "https://page.xchengtech.cn/productPage/qyce.html?channelId=74d16ae2bcb04dd48a7e0945ce976211",

          // 信用修复
          xyxf: "https://page.xchengtech.cn/productPage/xyxf.html?channelId=74d16ae2bcb04dd48a7e0945ce976211",
          // 债务优化
          zwyh: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=74d16ae2bcb04dd48a7e0945ce976211",
          // 补贴信息
          czbt: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=74d16ae2bcb04dd48a7e0945ce976211",
          // 资产配置
          zcpz: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=74d16ae2bcb04dd48a7e0945ce976211",
          // 账户管理
          zhgl: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=74d16ae2bcb04dd48a7e0945ce976211",
        },
        // 退役军人服务协会 xrr
        xrr: {
          channelId: "c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 企业报告
          csbg: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=1c53bdef1fcf46a1852654c4297661ea&channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 企业测额
          qyce: "https://page.xchengtech.cn/productPage/qyce.html?channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 信用修复
          xyxf: "https://page.xchengtech.cn/productPage/xyxf.html?channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 债务优化
          zwyh: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 补贴信息
          czbt: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 资产配置
          zcpz: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
          // 账户管理
          zhgl: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=c9ce3f5cb2f6411fb254e9e58b5d48fa",
        },
      },
      depName: "",
    };
  },
  methods: {
    getDepName() {
      this.depName = getDepNameByDomain();
    },
    toPage(name) {
      if (this.depLink[this.depName]) {
        let url = this.depLink[this.depName][name];

        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
          overlay: true,
        });
        // 延迟一小段时间后跳转，让用户看到加载提示
        setTimeout(() => {
          toast.close();
          window.location.href = url;
        }, 300);
      }
      // this.$router.push({ path: "/" + name });
    },
  },
};
</script>

<style scoped>
/* 图标地址：https://www.iconfont.cn/collections/detail?spm=a313x.collections_index.i1.d9df05512.7a783a81mVgjO2&cid=46911 */
/* 图标地址：https://www.iconfont.cn/collections/detail?spm=a313x.collections_index.i1.d9df05512.1ef73a81dm0cfn&cid=53134 */

/* 全屏loading样式 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2770f1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

.loading-text {
  color: #2770f1;
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 卡片滑入动画 */
.slide-in-item {
  opacity: 0;
  transform: translateX(-100px);
  animation: slideInLeft 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px) scale(0.9);
  }
  60% {
    opacity: 0.8;
    transform: translateX(10px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
.pageStyle {
  font-family: "黑体";
  padding-top: 49vw;
  background: url("https://static.xchengtech.cn/df82a75a7e664d699d7774781e85b11e.jpg");
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100%;
  background-color: #590100;
  min-height: 100vh;
  font-size: 3.6vw;
  padding-bottom: 17vw;
}
.content {
  display: grid;
  gap: 4vw;
  padding: 4vw;
}
.content .item {
  border-radius: 12px;
  padding: 5vw 4vw;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2vw;
  /* box-shadow: 0 4px 12px #c7e3fa; */
}
.content .item .left {
  display: flex;
  gap: 4vw;
}
.content .item .left .left-left {
  display: flex;
  align-items: center;
}

.content .item .left .left-left img {
  margin-top: 1px;
  display: block;
  width: 8vw;
}
.content .item .left .left-right {
  display: grid;
  gap: 1vw;
}
.content .item .left .left-right span:nth-of-type(1) {
  display: flex;
  align-items: center;
  gap: 2vw;
  font-weight: 600;
  font-size: 4.6vw;
  color: #2a4067;
}
.content .item .left .left-right span:nth-of-type(2) {
  /* padding-left: 5.6vw; */
  color: #aab3c4;
}

.content .item .right {
  display: flex;
  gap: 2vw;
  align-items: center;
}
.content .item .right img {
  display: block;
  height: 3.6vw;
}
.content .item .right .status {
  position: relative;
  color: #aab3c4;
  display: flex;
  align-items: center;
  gap: 1vw;
}

/* loading图标动画 */
.loading-spinner-small {
  width: 3vw;
  height: 3vw;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #2770f1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: 1vw;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.foot {
  padding-top: 20vw;
  display: flex;
  justify-content: center;
}
.foot span {
  display: flex;
  align-items: center;
  border: 1px solid #2770f1;
  border-radius: 35px;
  padding: 2vw 3vw;
  background-color: white;
  color: #2770f1;
  font-weight: 600;
  gap: 1vw;
}
.foot img {
  display: block;
  width: 5.2vw;
}
</style>


// WEBPACK FOOTER //
// src/view/productCollectionForXrr/index.vue